var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#DFE0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_2234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0625 10.6562H12.9375C12.0675 10.6572 11.2335 11.0031 10.6183 11.6183C10.0031 12.2335 9.65715 13.0675 9.65625 13.9375V23.125C9.65715 23.995 10.0031 24.829 10.6183 25.4442C11.2335 26.0594 12.0675 26.4053 12.9375 26.4062H17.894C18.3558 27.7193 19.2675 28.8266 20.4676 29.5316C21.6677 30.2367 23.0787 30.4941 24.4505 30.2583C25.8223 30.0224 27.0662 29.3085 27.9619 28.243C28.8576 27.1776 29.3471 25.8294 29.3438 24.4375C29.3344 24.2013 29.3106 23.9659 29.2725 23.7327C29.3156 23.5329 29.3394 23.3294 29.3438 23.125V13.9375C29.3428 13.0675 28.9969 12.2335 28.3817 11.6183C27.7665 11.0031 26.9325 10.6572 26.0625 10.6562ZM12.9375 11.9688H26.0625C26.5845 11.9693 27.0849 12.177 27.454 12.546C27.823 12.9151 28.0307 13.4155 28.0312 13.9375V14.5938H10.9688V13.9375C10.9693 13.4155 11.177 12.9151 11.546 12.546C11.9151 12.177 12.4155 11.9693 12.9375 11.9688ZM23.4375 29.0312C22.5289 29.0312 21.6408 28.7618 20.8853 28.2571C20.1299 27.7523 19.5411 27.0348 19.1934 26.1955C18.8457 25.3561 18.7548 24.4324 18.932 23.5413C19.1093 22.6502 19.5468 21.8317 20.1892 21.1892C20.8317 20.5468 21.6502 20.1093 22.5413 19.932C23.4324 19.7548 24.3561 19.8457 25.1955 20.1934C26.0348 20.5411 26.7523 21.1299 27.2571 21.8853C27.7618 22.6408 28.0312 23.5289 28.0312 24.4375C28.0298 25.6554 27.5453 26.823 26.6842 27.6842C25.823 28.5453 24.6554 29.0298 23.4375 29.0312ZM23.4375 18.5312C21.8716 18.533 20.3703 19.1558 19.2631 20.2631C18.1558 21.3703 17.533 22.8716 17.5312 24.4375C17.5409 24.6573 17.563 24.8764 17.5975 25.0938H12.9375C12.4155 25.0932 11.9151 24.8855 11.546 24.5165C11.177 24.1474 10.9693 23.647 10.9688 23.125V15.9062H28.0312V20.771C27.4837 20.0757 26.7862 19.5132 25.9908 19.1253C25.1953 18.7375 24.3225 18.5344 23.4375 18.5312Z",
    fill: "url(#paint0_linear_2624_2234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.5312H12.9375C12.7635 18.5312 12.5965 18.6004 12.4735 18.7235C12.3504 18.8465 12.2812 19.0135 12.2812 19.1875C12.2812 19.3615 12.3504 19.5285 12.4735 19.6515C12.5965 19.7746 12.7635 19.8438 12.9375 19.8438H16.875C17.049 19.8438 17.216 19.7746 17.339 19.6515C17.4621 19.5285 17.5312 19.3615 17.5312 19.1875C17.5312 19.0135 17.4621 18.8465 17.339 18.7235C17.216 18.6004 17.049 18.5312 16.875 18.5312Z",
    stroke: "url(#paint1_linear_2624_2234)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1094 23.7813C23.2391 23.7813 23.366 23.7427 23.4739 23.6706C23.5818 23.5985 23.6659 23.496 23.7155 23.3761C23.7652 23.2562 23.7782 23.1243 23.7529 22.997C23.7276 22.8698 23.6651 22.7528 23.5733 22.6611L22.2616 21.3493C22.1382 21.2264 21.9711 21.1573 21.7969 21.1573C21.6226 21.1573 21.4555 21.2264 21.3321 21.3493L20.0204 22.6611C19.9009 22.7848 19.8347 22.9506 19.8362 23.1227C19.8377 23.2947 19.9067 23.4593 20.0284 23.581C20.1501 23.7027 20.3147 23.7717 20.4867 23.7732C20.6588 23.7747 20.8246 23.7085 20.9483 23.589L21.1406 23.3967V25.75C21.1406 25.9241 21.2098 26.091 21.3328 26.2141C21.4559 26.3371 21.6228 26.4063 21.7969 26.4063C21.9709 26.4063 22.1378 26.3371 22.2609 26.2141C22.384 26.091 22.4531 25.9241 22.4531 25.75V23.3967L22.6454 23.589C22.7062 23.6501 22.7786 23.6985 22.8582 23.7315C22.9378 23.7645 23.0232 23.7814 23.1094 23.7813Z",
    fill: "url(#paint2_linear_2624_2234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9266 25.286L25.7344 25.4783V23.125C25.7344 22.951 25.6652 22.784 25.5422 22.661C25.4191 22.5379 25.2522 22.4688 25.0781 22.4688C24.9041 22.4688 24.7371 22.5379 24.6141 22.661C24.491 22.784 24.4219 22.951 24.4219 23.125V25.4783L24.2296 25.286C24.1058 25.1665 23.94 25.1003 23.768 25.1018C23.5959 25.1033 23.4313 25.1724 23.3096 25.294C23.188 25.4157 23.119 25.5803 23.1175 25.7524C23.116 25.9244 23.1821 26.0902 23.3016 26.214L24.6134 27.5257C24.7368 27.6487 24.9039 27.7177 25.0781 27.7177C25.2523 27.7177 25.4195 27.6487 25.5429 27.5257L26.8546 26.214C26.9741 26.0902 27.0403 25.9244 27.0388 25.7524C27.0373 25.5803 26.9683 25.4157 26.8466 25.294C26.7249 25.1724 26.5603 25.1033 26.3883 25.1018C26.2162 25.1003 26.0504 25.1665 25.9266 25.286Z",
    fill: "url(#paint3_linear_2624_2234)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2624_2234",
    x1: 19.5,
    y1: 10.6562,
    x2: 19.5,
    y2: 30.3435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2624_2234",
    x1: 21.4732,
    y1: 19.8842,
    x2: 21.4732,
    y2: 18.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2624_2234",
    x1: 21.8008,
    y1: 21.1573,
    x2: 21.8008,
    y2: 26.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2624_2234",
    x1: 25.0781,
    y1: 22.4688,
    x2: 25.0781,
    y2: 27.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262D7D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_2234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.7ee5ce291e463df8aad4a9cb739d83d4.svg";
export { ForwardRef as ReactComponent };